import { FileIconPreview } from '../../FileIcon'
import { getTagActionSize, Tag, TAG_HEIGHT } from '../../Tag'
import { getFileSize } from '../File.utils'

import { FileAttachTagStatuses } from './FileAttachTagStatuses'

import * as styles from './FileAttachTag.module.css'

function FileAttachTag({
  className = styles.FileAttachTag,
  file,
  fileType,
  height = TAG_HEIGHT.height40,
  link,
  onClick,
  onRemove,
  ...restProps
}) {
  const hasStatuses = Boolean(file?.error || file?.link || link)

  function handleClick() {
    return onClick(file)
  }

  function handleRemove() {
    return onRemove(file)
  }

  return (
    <Tag
      {...restProps}
      beforeContent={
        <FileIconPreview
          file={file}
          size={getTagActionSize(height)}
          type={fileType}
        />
      }
      className={className}
      height={height}
      isLoading={Boolean(file?.uploading && !file?.error)}
      meta={
        hasStatuses ? (
          <FileAttachTagStatuses
            file={file}
            height={getTagActionSize(height)}
            link={link}
          />
        ) : undefined
      }
      secondText={
        file?.size ? (
          <span className={styles.fileSize}>{getFileSize({ file })}</span>
        ) : undefined
      }
      text={file?.name}
      onClick={onClick ? handleClick : undefined}
      onRemove={onRemove ? handleRemove : undefined}
    />
  )
}

export default FileAttachTag
